export class SetUtil {
  public static toggle<T>(set: Set<T>, item: T): void {
    if (set.has(item)) {
      set.delete(item)
    } else {
      set.add(item)
    }
  }
}
